<script setup>
import { computed, toRefs } from "vue"
import { useLazyAsyncData } from "nuxt/app"
import { storeToRefs } from "pinia"
import {
  formatPadding,
  formatHeight,
  formatWidth,
} from "~~/models/layout/style"
import { usePageBuilder } from "~/stores/page-builder"
// Define props for the component
const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: false,
  },
  rowOrder: {
    type: Number,
    required: true,
  },
})

// Extract data from props
const { data } = toRefs(props)

// Get the page builder store
const pageBuilderStore = usePageBuilder()
const { deviceType, content } = storeToRefs(pageBuilderStore)

// Use `useLazyAsyncData` to load data lazily on the client side
const { data: fetchedText, error } = await useLazyAsyncData(
  "fetchRichTextContent",
  async () => {
    // console.log(data.value.props.richTextType)
    // if (data.value.props?.richTextType === 2) {
    //   const queryId = data.value.props.dynamicData.query?.id
    //   const contentId = [data.value.props?.dynamicData?.contentId] || ""
    //   const params = {
    //     take: 1,
    //   }
    //   console.log(queryId, contentId, params)
    //   let response
    //   const res = await pageBuilderStore.actionGetQueryDataInitClient(
    //     queryId,
    //     params,
    //     contentId,
    //     false,
    //     props.rowOrder
    //   )
    //   if (res) {
    //     response = res
    //   }
    //   console.log(response)
    //   if (response && response !== -1) {
    //     return response // Return the fetched text if available
    //   }
    // }
    // // Default fallback if no response is fetched
    // return data.value.props.text || ""
    if (
      data.value.props?.richTextType === 2 &&
      data.value.props?.dynamicData?.contextBased
    ) {
      data.value.props.text = content.value.description
    } else {
      data.value.props.text = data.value.props.text
    }
    return data.value.props.text
  }
)

// Computed style based on data values
const style = computed(() => {
  return {
    ...formatPadding(data.value.style.padding),
    height: formatHeight(data.value.style.height),
    width: formatWidth(data.value.style.width),
    color: data.value?.style.color,
  }
})
</script>

<template>
  <div
    class="richtextcontent ql-editor"
    :style="style"
    v-html="fetchedText || data.props.text"
  />
</template>
